import { render } from "./UrgentFlag.vue?vue&type=template&id=0c61f2ca&scoped=true&ts=true&lang=pug"
import script from "./UrgentFlag.vue?vue&type=script&lang=ts"
export * from "./UrgentFlag.vue?vue&type=script&lang=ts"

import "./UrgentFlag.vue?vue&type=style&index=0&id=0c61f2ca&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c61f2ca"]])

export default __exports__